import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  organization: Yup.number().notOneOf([0], 'Şirket zorunludur.'),
  first_name: Yup.string().required('İsim zorunludur.'),
  last_name: Yup.string().required('Soyisim zorunludur.'),
  turkish_id: Yup.string()
    .required('TCKN zorunludur.')
    .matches(/^\d{11}$/, 'TCKN 11 haneli olmalıdır.'),
  policy: Yup.number().notOneOf([0], 'Poliçe tipi zorunludur.'),
  date_of_employment: Yup.string().required('⁠İşe Giriş Tarihi zorunludur.'),
  gsm: Yup.string().required('GSM zorunludur.'),
  gender: Yup.string().required('Cinsiyet zorunludur.'),
  nationality: Yup.string().required('Uyruk zorunludur.'),
  birthday: Yup.string().required('Doğum tarihi zorunludur.'),
});

export default validationSchema;
